module.exports = __webpack_public_path__ + "img/my.39895ac4.svg";